exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transaction-log-table thead th:nth-child(1) {\r\n    width: 9%;\r\n}\r\n.transaction-log-table thead th:nth-child(2) {\r\n    width: 9%;\r\n}\r\n.transaction-log-table thead th:nth-child(3) {\r\n    width: 9%;\r\n}\r\n.transaction-log-table thead th:nth-child(4) {\r\n    width: 8%;\r\n}\r\n.transaction-log-table thead th:nth-child(5) {\r\n    width: 15%;\r\n}\r\n.transaction-log-table thead th:nth-child(6) {\r\n    width: 9%;\r\n}\r\n.transaction-log-table thead th:nth-child(7) {\r\n    width: 8%;\r\n}\r\n.transaction-log-table thead th:nth-child(8) {\r\n    width: 9%;\r\n}\r\n.transaction-log-table thead th:nth-child(9) {\r\n    width: 8%;\r\n}\r\n.transaction-log-table thead th:nth-child(10) {\r\n    width: 8%;\r\n}\r\n.transaction-log-table thead th:nth-child(11) {\r\n    width: 8%;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/views/admin/transaction-log/transaction-log-management-table.css
// module id = 984
// module chunks = 0